import { X, CheckCircle } from 'lucide-react'
import { estiloDeBoton } from '@/shared/lib/estilosDeBoton'

interface SuccessModalProps {
  isOpen: boolean
  onClose: () => void
  title: string
  message: string
}

const SuccessModal = ({ isOpen, onClose, title, message }: SuccessModalProps) => {
  if (!isOpen) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative bg-white rounded-2xl shadow-xl max-w-lg w-full mx-4 p-8 animate-fadeIn">
        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-6 h-6" />
        </button>

        {/* Content */}
        <div className="text-center">
          {/* Title */}
          <h2 className="text-2xl font-bold text-gray-900 mb-8">
            {title}
          </h2>

          {/* Icon */}
          <div className="flex justify-center mb-8">
            <CheckCircle className="w-24 h-24 text-blue-500" strokeWidth={1.5} />
          </div>

          {/* Message */}
          <p className="text-gray-700 text-lg leading-relaxed mb-8">
            {message}
          </p>

          {/* Button */}
          <button
            onClick={onClose}
            className={estiloDeBoton('primario', 'w-full max-w-xs mx-auto')}
          >
            Continuar
          </button>
        </div>
      </div>
    </div>
  )
}

export default SuccessModal
